export default [
  {
    path: '/demo-control',
    name: 'demoControl',
    component: () => import('@/views/demo/DemoControl.vue'),
    meta: {
      anonymous: true,
    },
  },
  {
    path: '/demo-combobox',
    name: 'demoCombobox',
    component: () => import('@/views/demo/DemoCombobox.vue'),
    meta: {
      anonymous: true,
    },
  },
  {
    path: '/demo-grid-view-normal',
    name: 'demoGridViewNormal',
    component: () => import('@/views/demo/DemoGridViewNormal.vue'),
    meta: {
      anonymous: true,
    },
  },
  {
    path: '/demo-grid-edit',
    name: 'demoGridEdit',
    component: () => import('@/views/demo/DemoGridEdit.vue'),
    meta: {
      anonymous: true,
    },
  },
  {
    path: '/demo-combobox',
    name: 'demoCombobox',
    component: () => import('@/views/demo/DemoCombobox.vue'),
    meta: {
      anonymous: true,
    },
  },
  {
    path: '/demo-grid-view-normal',
    name: 'demoGridViewNormal',
    component: () => import('@/views/demo/DemoGridViewNormal.vue'),
    meta: {
      anonymous: true,
    },
  },
  {
    path: '/demo-grid-edit',
    name: 'demoGridEdit',
    component: () => import('@/views/demo/DemoGridEdit.vue'),
    meta: {
      anonymous: true,
    },
  },
  {
    path: '/demo-form',
    name: 'demoForm',
    component: () => import('@/views/demo/DemoForm.vue'),
    meta: {
      anonymous: true,
    },
  },
  {
    path: '/demo-message',
    name: 'demoMessage',
    component: () => import('@/views/demo/DemoMessage.vue'),
    meta: {
      anonymous: true,
    },
  },
  {
    path: '/demo-toast',
    name: 'demoToast',
    component: () => import('@/views/demo/DemoToast.vue'),
    meta: {
      anonymous: true,
    },
  },
  {
    path: '/account-combo',
    name: 'accountCombo',
    component: () => import('@/views/dictionary/account/AccountCombobox.vue'),
    meta: {},
  },
  {
    path: '/account-editor',
    name: 'accountEditor',
    component: () => import('@/views/dictionary/account/AccountListEditor.vue'),
    meta: {},
  },
  {
    path: '/demo-super',
    name: 'demoSuper',
    component: () => import('@/views/demo/DemoSuper.vue'),
    meta: {
      anonymous: true,
    },
  },
];
